/**
 * The rules the table enforces in words (review 0024): why a card was refused (decision 172), leaving a
 * match (171) and a seat the table plays for its player (173). Apart, so each language file stays in budget.
 */
export const rulesEn = {
  "error.not-your-turn": "Not your turn.",
  "error.card-not-playable": "You cannot play that card now.",
  "error.invalid-bid": "That bid is not allowed.",
  "table.leave.title": "Leave the match?",
  "table.leave.body":
    "A bot takes your seat, you cannot come back, and the match counts as a loss for you.",
  "table.leave.stay": "Stay",
  "table.leave.go": "Leave",
  "table.auto.title": "Your seat is being played for you",
  "table.auto.take": "Take over",
  "table.seat.auto": "Auto",
  "error.follow-suit": "You must follow the suit that was led.",
  "error.beat-in-suit": "You must beat the winning card in that suit.",
  "error.must-trump": "You are out of that suit: you must play a trump.",
  "error.overtrump": "You must play a higher trump.",
  "error.trump-not-broken": "Trumps are not broken yet.",
  "error.spades-not-broken": "Spades are not broken yet.",
};

export const rulesTr = {
  "error.not-your-turn": "Sıra sende değil.",
  "error.card-not-playable": "Bu kart şu an oynanamaz.",
  "error.invalid-bid": "Bu ihale geçersiz.",
  "table.leave.title": "Maçtan çık?",
  "table.leave.body": "Yerine bot geçer, bu maça geri dönemezsin ve maç sana kayıp yazılır.",
  "table.leave.stay": "Kal",
  "table.leave.go": "Çık",
  "table.auto.title": "Sıran geldiğinde otomatik oynanıyor",
  "table.auto.take": "Devral",
  "table.seat.auto": "Otomatik",
  "error.follow-suit": "Açılan renge uymalısın.",
  "error.beat-in-suit": "O renkte kazanan kartı geçmelisin.",
  "error.must-trump": "O renk elinde yok: koz atmalısın.",
  "error.overtrump": "Daha büyük koz atmalısın.",
  "error.trump-not-broken": "Koz henüz kırılmadı.",
  "error.spades-not-broken": "Maça henüz kırılmadı.",
};

export const rulesAr = {
  "error.not-your-turn": "ليس دورك.",
  "error.card-not-playable": "لا يمكنك لعب هذه الورقة الآن.",
  "error.invalid-bid": "هذا الطلب غير مسموح.",
  "table.leave.title": "هل تغادر المباراة؟",
  "table.leave.body": "سيأخذ بوت مقعدك ولن تتمكن من العودة، وتُحتسب المباراة خسارة لك.",
  "table.leave.stay": "ابق",
  "table.leave.go": "غادر",
  "table.auto.title": "يتم اللعب عنك تلقائيًا",
  "table.auto.take": "استعد مقعدك",
  "table.seat.auto": "تلقائي",
  "error.follow-suit": "يجب أن تتبع اللون المطلوب.",
  "error.beat-in-suit": "يجب أن تتجاوز الورقة الرابحة في اللون نفسه.",
  "error.must-trump": "ليس لديك هذا اللون: يجب أن تلعب حكمًا.",
  "error.overtrump": "يجب أن تلعب حكمًا أعلى.",
  "error.trump-not-broken": "لم يُكسر الحكم بعد.",
  "error.spades-not-broken": "لم تُكسر البستوني بعد.",
};
